<template>
  <div class="page-container">
    <PageHeader title="PK规则" show-breadcrumb>
      <template #actions>
        <el-button type="primary" icon="el-icon-check" size="small" :loading="saving" @click="handleSave">保存规则</el-button>
      </template>
    </PageHeader>

    <el-card v-loading="loading" shadow="never" class="rule-card">
      <div slot="header">
        <span style="font-weight:600;">PK 全局规则配置</span>
        <span style="color:#909399; font-size:12px; margin-left:10px;">每场固定 5 题 · 配置当前项目下所有 PK 对战的通用规则</span>
      </div>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="160px" size="small" style="max-width:640px;">
        <el-form-item label="单题倒计时(秒)" prop="pkCountdownSecond">
          <el-input-number v-model="form.pkCountdownSecond" :min="5" controls-position="right" />
          <span class="rule-tip">每道题的答题倒计时秒数（≥5）</span>
        </el-form-item>
        <el-form-item label="每题分值" prop="pkScore">
          <el-input-number v-model="form.pkScore" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">答对一题得分（0-100）</span>
        </el-form-item>
        <el-form-item label="胜利得分" prop="pkPointsWin">
          <el-input-number v-model="form.pkPointsWin" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">PK 胜利方额外得分（0-100）</span>
        </el-form-item>
        <el-form-item label="失败得分" prop="pkPointsLose">
          <el-input-number v-model="form.pkPointsLose" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">PK 失败方得分（0-100，需小于胜利得分）</span>
        </el-form-item>
        <el-form-item label="平局得分" prop="pkPointsDraw">
          <el-input-number v-model="form.pkPointsDraw" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">PK 平局双方得分（0-100）</span>
        </el-form-item>
        <!-- 连胜加分：新规则为「固定加分」——达到开始局数后每场胜局固定加 n 分，不再累进 -->
        <el-form-item label="连胜单次加分" prop="pkPointsWinningStreak">
          <el-input-number v-model="form.pkPointsWinningStreak" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">达到开始局数后，每场胜利固定加 n 分（0-100，不累进）</span>
        </el-form-item>
        <el-form-item label="连胜开始局数" prop="pkPointsWinningStreakStart">
          <el-input-number v-model="form.pkPointsWinningStreakStart" :min="1" :max="100" controls-position="right" />
          <span class="rule-tip">连胜达到 N 局起开始加分（含第 N 局，1-100，未配置默认 3）</span>
        </el-form-item>
        <el-divider content-position="left">进阶规则</el-divider>
        <!-- 每日 PK 次数上限：0 表示不限制 -->
        <el-form-item label="每日PK上限" prop="pkTimesDay">
          <el-input-number v-model="form.pkTimesDay" :min="0" controls-position="right" />
          <span class="rule-tip">每个用户每天最多可进行 PK 的次数（0=不限）</span>
        </el-form-item>
        <!-- 答题速度加分：胜利且用时小于满额时间(题数×倒计时)的可配比例时额外加分 -->
        <el-form-item label="答题速度加分" prop="pkPointsSpeed">
          <el-input-number v-model="form.pkPointsSpeed" :min="0" :max="100" controls-position="right" />
          <span class="rule-tip">胜利且用时&lt;满额时间×阈值%时额外加分（0-100，0=不启用）</span>
        </el-form-item>
        <el-form-item label="速度阈值(%)" prop="pkSpeedTimePercent">
          <el-input-number v-model="form.pkSpeedTimePercent" :min="1" :max="100" controls-position="right" />
          <span class="rule-tip">实际用时&lt;满额时间×该比例才加速度分（1-100，未配置默认 20）</span>
        </el-form-item>
        <!-- 最后一题多选：1否 2是；为 2 时末题强制多选且分值翻倍 -->
        <el-form-item label="最后一题多选" prop="pkScoreLast">
          <el-radio-group v-model="form.pkScoreLast">
            <el-radio :label="1">关闭</el-radio>
            <el-radio :label="2">开启（末题多选·分值翻倍）</el-radio>
          </el-radio-group>
          <span class="rule-tip">开启后最后一题强制为多选题，难度加大且分数翻倍</span>
        </el-form-item>
        <!-- PK 规则文字描述：展示在 H5 PK 大厅规则卡，支持换行 -->
        <el-form-item label="规则描述" prop="pkRuleDes">
          <el-input
            v-model="form.pkRuleDes"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
            placeholder="展示在 H5 PK 大厅规则卡，支持换行；如：1.每天最多5局PK&#10;2.最后一题为多选题..."
          />
          <span class="rule-tip">H5 用户端 PK 规则卡展示的文字描述</span>
        </el-form-item>
        <el-divider content-position="left">机器人配置</el-divider>
        <!-- 机器人胜率：后端字段 pkRobotWinRate 为 JSON 字符串数组，如 "[50,80]"，前端用两个输入框组合 -->
        <el-form-item label="机器人胜率(%)" prop="pkRobotWinRateMin">
          <el-input-number v-model="form.pkRobotWinRateMin" :min="10" :max="100" controls-position="right" style="width:130px" />
          <span style="margin:0 8px;color:#909399;">~</span>
          <el-input-number v-model="form.pkRobotWinRateMax" :min="10" :max="100" controls-position="right" style="width:130px" />
          <span class="rule-tip">机器人胜率范围（最小 ~ 最大，10-100）</span>
        </el-form-item>
        <el-form-item label="机器人等待加入(s)" prop="pkRobotWait">
          <el-input-number v-model="form.pkRobotWait" :min="5" :max="120" controls-position="right" />
          <span class="rule-tip">机器人等待加入时间（5-120 秒）</span>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import { getPkqRuleGlobalDetails, updatePkqRuleGlobal } from '@/api/api'

// 解析机器人胜率 JSON 字符串数组（如 "[50,80]"）的指定下标，失败回退 0
function parseRateIndex (raw, idx) {
  try {
    const arr = typeof raw === 'string' ? JSON.parse(raw) : raw
    if (Array.isArray(arr) && arr[idx] != null) return Number(arr[idx]) || 0
  } catch (e) {}
  return 0
}

export default {
  name: 'PkqRule',
  components: { PageHeader },
  data () {
    // 失败得分必须小于胜利得分
    const validateLose = (rule, value, callback) => {
      if (value != null && this.form.pkPointsWin != null && Number(value) >= Number(this.form.pkPointsWin)) {
        callback(new Error('失败得分需小于胜利得分'))
      } else {
        callback()
      }
    }
    // 机器人胜率范围校验：min/max 均在 0-100，且 min ≤ max
    const validateRobotRateMin = (rule, value, callback) => {
      const max = this.form.pkRobotWinRateMax
      if (value != null && max != null && Number(value) > Number(max)) {
        return callback(new Error('最小值不能大于最大值'))
      }
      // 联动校验对方
      if (this.$refs.formRef) this.$refs.formRef.validateField('pkRobotWinRateMax')
      callback()
    }
    const validateRobotRateMax = (rule, value, callback) => {
      const min = this.form.pkRobotWinRateMin
      if (value != null && min != null && Number(value) < Number(min)) {
        return callback(new Error('最大值不能小于最小值'))
      }
      callback()
    }
    return {
      loading: false,
      saving: false,
      form: {
        prgId: null,
        pkCountdownSecond: 15,
        pkScore: 10,
        pkPointsWin: 0,
        pkPointsLose: 0,
        pkPointsDraw: 0,
        pkPointsWinningStreak: 0,
        // 连胜开始局数：连胜达到 N 局（含第 N 局胜利）起每局加「连胜单次加分」；后端未配置默认 3
        pkPointsWinningStreakStart: 3,
        // 机器人胜率范围（后端字段 pkRobotWinRate 为 JSON 字符串数组 "[min,max]"，前端拆成两个数值展示与编辑）
        pkRobotWinRateMin: 10,
        pkRobotWinRateMax: 80,
        pkRobotWait: 5,
        // 20260731 新增规则字段
        pkTimesDay: 0, // 每日 PK 上限（0=不限）
        pkPointsSpeed: 0, // 答题速度加分（0=不启用）
        pkSpeedTimePercent: 20, // 速度加分用时阈值%（后端未配置默认 20）
        pkScoreLast: 1, // 最后一题多选（1否 2是）
        pkRuleDes: '' // PK 规则文字描述（H5 展示）
      },
      rules: {
        pkCountdownSecond: [{ type: 'number', min: 5, message: '倒计时需 ≥ 5 秒', trigger: 'change' }],
        pkScore: [{ type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' }],
        pkPointsWin: [{ type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' }],
        pkPointsLose: [
          { type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' },
          { validator: validateLose, trigger: 'change' }
        ],
        pkPointsDraw: [{ type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' }],
        pkPointsWinningStreak: [{ type: 'number', min: 0, max: 100, message: '范围 0-100', trigger: 'change' }],
        pkPointsWinningStreakStart: [{ type: 'number', min: 1, max: 100, message: '范围 1-100', trigger: 'change' }],
        pkTimesDay: [{ type: 'number', min: 0, message: '需 ≥ 0（0=不限）', trigger: 'change' }],
        pkPointsSpeed: [{ type: 'number', min: 0, max: 100, message: '范围 0-100（0=不启用）', trigger: 'change' }],
        pkSpeedTimePercent: [{ type: 'number', min: 1, max: 100, message: '范围 1-100', trigger: 'change' }],
        pkScoreLast: [{ type: 'number', validator: (rule, value, cb) => (value === 1 || value === 2) ? cb() : cb(new Error('请选择')), trigger: 'change' }],
        pkRobotWinRateMin: [
          { type: 'number', min: 10, max: 100, message: '范围 10-100', trigger: 'change' },
          { validator: validateRobotRateMin, trigger: 'change' }
        ],
        pkRobotWinRateMax: [
          { type: 'number', min: 10, max: 100, message: '范围 10-100', trigger: 'change' },
          { validator: validateRobotRateMax, trigger: 'change' }
        ],
        pkRobotWait: [{ type: 'number', min: 5, max: 120, message: '范围 5-120 秒', trigger: 'change' }]
      }
    }
  },
  created () { this.fetchDetail() },
  methods: {
    // 获取当前项目 PK 全局规则（不存在后端会自动初始化）
    async fetchDetail () {
      this.loading = true
      try {
        const res = await getPkqRuleGlobalDetails()
        const d = res.data || {}
        this.form = {
          prgId: d.prgId || null,
          pkCountdownSecond: Number(d.pkCountdownSecond) || 15,
          pkScore: Number(d.pkScore) || 0,
          pkPointsWin: Number(d.pkPointsWin) || 0,
          pkPointsLose: Number(d.pkPointsLose) || 0,
          pkPointsDraw: Number(d.pkPointsDraw) || 0,
          pkPointsWinningStreak: Number(d.pkPointsWinningStreak) || 0,
          // 连胜开始局数：后端未配置时按默认 3 回显
          pkPointsWinningStreakStart: Number(d.pkPointsWinningStreakStart) > 0 ? Number(d.pkPointsWinningStreakStart) : 3,
          // 机器人胜率：后端返回 "[min,max]" 字符串，解析为两个数值；异常时回退 50~80
          pkRobotWinRateMin: parseRateIndex(d.pkRobotWinRate, 0) || 50,
          pkRobotWinRateMax: parseRateIndex(d.pkRobotWinRate, 1) || 80,
          pkRobotWait: Number(d.pkRobotWait) >= 5 ? Number(d.pkRobotWait) : 5,
          // 20260731 新增字段回显（注意兜底默认值）
          pkTimesDay: Number(d.pkTimesDay) || 0,
          pkPointsSpeed: Number(d.pkPointsSpeed) || 0,
          pkSpeedTimePercent: Number(d.pkSpeedTimePercent) > 0 ? Number(d.pkSpeedTimePercent) : 20,
          pkScoreLast: Number(d.pkScoreLast) === 2 ? 2 : 1,
          pkRuleDes: d.pkRuleDes || ''
        }
      } catch (e) {} finally {
        this.loading = false
      }
    },
    handleSave () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          // 提交时将 min/max 合并为后端期望的 JSON 字符串数组 "[min,max]"
          const payload = { ...this.form }
          payload.pkRobotWinRate = JSON.stringify([this.form.pkRobotWinRateMin, this.form.pkRobotWinRateMax])
          delete payload.pkRobotWinRateMin
          delete payload.pkRobotWinRateMax
          await updatePkqRuleGlobal(payload)
          this.$message.success('保存成功')
          this.fetchDetail()
        } catch (e) {} finally {
          this.saving = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rule-card { max-width: 880px; margin: 0 auto; }
.rule-tip { display: inline-block; margin-left: 12px; color: #909399; font-size: 12px; }
</style>
